module.exports = __webpack_public_path__ + "img/icon-status-02.ebeed4bb.svg";